import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { Providers } from "@/context/Providers";
import { AgeGate } from "@/components/AgeGate";
import { PromoPopup } from "@/components/PromoPopup";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { MobileBar } from "@/components/MobileBar";
import { Analytics } from "@/components/Analytics";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import ContentPage from "@/pages/ContentPage";
import Faq from "@/pages/Faq";
import { LocationPage, Locations } from "@/pages/Locations";
import Blog, { BlogPost } from "@/pages/Blog";
import Contact from "@/pages/Contact";
import CartPage from "@/pages/Cart";
import Checkout, { OrderConfirmation } from "@/pages/Checkout";
import NotFound, { LegacyRedirect } from "@/pages/NotFound";
import { PAGES } from "@/content/pages";

const LEGACY = ["/product/*", "/product-category/*", "/product-tag/*", "/my-account/*", "/my-account-2/*", "/wishlist/*", "/wishlist-2/*", "/sample-page/*", "/medical-clinic/*"];

function App() {
  return (
    <BrowserRouter>
      <Providers>
        <Analytics />
        <AgeGate />
        <PromoPopup />
        <Header />
        <main id="main" className="min-h-[60vh] pb-8">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop/" element={<Shop />} />
            <Route path="/shop/product/:slug/" element={<Product />} />
            <Route path="/shop/deals/" element={<Shop deals />} />
            <Route path="/shop/:category/" element={<Shop />} />
            <Route path="/deals/" element={<Shop deals />} />
            <Route path="/faq/" element={<Faq />} />
            <Route path="/locations/" element={<Locations />} />
            <Route path="/locations/:slug/" element={<LocationPage />} />
            <Route path="/blog/" element={<Blog />} />
            <Route path="/blog/:slug/" element={<BlogPost />} />
            <Route path="/contact/" element={<Contact />} />
            <Route path="/cart/" element={<CartPage />} />
            <Route path="/checkout/" element={<Checkout />} />
            <Route path="/order-confirmation/" element={<OrderConfirmation />} />
            {Object.keys(PAGES).map((slug) => <Route key={slug} path={`/${slug}/`} element={<ContentPage />} />)}
            {LEGACY.map((p) => <Route key={p} path={p} element={<LegacyRedirect />} />)}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <MobileBar />
        <CartDrawer />
        <Toaster theme="dark" position="top-center" richColors />
      </Providers>
    </BrowserRouter>
  );
}

export default App;
